import { render, staticRenderFns } from "./DetailPayment.vue?vue&type=template&id=7af41151"
import script from "./DetailPayment.vue?vue&type=script&lang=js"
export * from "./DetailPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports